module.exports = __webpack_public_path__ + "static/media/marek_wolfryd_20.a249f5e6.jpg";